import PaymentMethodsModal from './PaymentMethodsModal';
import AddCreditCard from './add-credit-card';
import AddAdyenCard from './add-adyen-card';

export default {
  PaymentMethodsModal,
  AddCreditCard,
  AddAdyenCard,
};
